import React, { useEffect, useState } from 'react'
import { AppDispatch, RootState } from '@redux/store'
import { useDispatch, useSelector } from 'react-redux'
import { Dropdown, Button } from 'antd';
import { Link, useLocation } from 'react-router-dom'
import routerConstants from '@constants/routerConstants'
import { userMenu } from '@constants/menuConstants'
import { role } from '@constants/roleConstants'
import {
  getUserRole, logOut, getSystemInfo,
  saveAccessToken, saveUserRole, saveSystemInfo, saveUserInfo,
  getManagedHeThongIds, getDisplayUsername, saveManagedHeThongIds, saveManagedDuAnIds,
} from '@utils/userUtils'
import * as userApi from '@api/userApi'
import { AppstoreOutlined, SyncOutlined, UserOutlined } from '@ant-design/icons'
import { getListDuAn } from '@redux/ducks/duAnDucks'
import { getListChiNhanh } from '@redux/ducks/chiNhanhDucks'
import { getListHeThong } from '@redux/ducks/heThongDucks';
import ThemePickerPopover from './ThemePickerPopover'
import * as userSyncApi from '@api/userSyncApi'
import { showMessage } from '@/utils/commonUtils';
import * as queryString from 'query-string'
interface Props { }

const HeaderMenu: React.FC<Props> = () => {
  const dispatch: AppDispatch = useDispatch()
  const { pathname } = useLocation()
  const systemInfo = getSystemInfo()
  const user_role = getUserRole()
  const [displayUsername, setDisplayUsername] = useState(() => getDisplayUsername())
  const managedHeThongIds = getManagedHeThongIds()
  const isSubAdmin = managedHeThongIds.length > 0
  const canSyncUser = user_role === role.SUPPER_ADMIN || isSubAdmin
  const [systems, setSystems] = useState<any[]>([])
  const [chiNhanhArray, setChiNhanhArray] = useState<any[]>([])
  const heThongList = useSelector((state: RootState) => state.heThong.heThongList || {})
  const chiNhanhList = useSelector((state: RootState) => state.chiNhanh.chiNhanhList || [])

  useEffect(() => {
    getCommonData()
  }, [])

  useEffect(() => {
    const name = getDisplayUsername()
    if (name) {
      setDisplayUsername(name)
      return
    }
    userApi.getUserInfo()
      .then((res: any) => {
        const user = res?.data
        if (user?.username) {
          saveUserInfo(user)
          setDisplayUsername(user.username)
        }
      })
      .catch(() => {})
  }, [])

  const getCommonData = () => {
    const stringified = queryString.stringify({page: 1, page_size: 100})
    dispatch(getListHeThong(stringified))
    dispatch(getListDuAn(stringified))
    dispatch(getListChiNhanh(stringified))
  }

  useEffect(() => {
    setSystems(heThongList?.data || [])
  }, [JSON.stringify(heThongList)])

  useEffect(() => {
    setChiNhanhArray(chiNhanhList?.data || [])
  }, [JSON.stringify(chiNhanhList)])

  const changeHeThong = async (item: any) => {
    try {
      const res = await userApi.changeHeThong(item.id)
      const token = res.data.access_token
      const jwtPayload = JSON.parse(atob(token.split('.')[1]))
      saveAccessToken(token)
      saveUserRole(jwtPayload.role)
      saveSystemInfo(JSON.stringify(res.data.heThong))
      saveManagedHeThongIds(jwtPayload.managedHeThongIds || [])
      saveManagedDuAnIds(jwtPayload.managedDuAnIds || [])
      const resUser = await userApi.getUserInfo()
      saveUserInfo(resUser.data)
      window.location.reload()
    } catch (error: any) {
      showMessage('error', error?.message || 'Đổi phần mềm thất bại')
    }
  }

  const handleSyncUser = async () => {
    try {
      const branchesToSync = isSubAdmin && user_role !== role.SUPPER_ADMIN
        ? chiNhanhArray.filter((c: any) => Number(c.heThongId) === Number(systemInfo?.id))
        : chiNhanhArray
      await userSyncApi.syncUser(systemInfo?.ma || '', branchesToSync)
      showMessage('success', 'Đồng bộ user thành công')
    } catch (error: any) {
      showMessage('error', error?.message || 'Đồng bộ user thất bại')
    }
  }

  const systemMenuItems = (() => {
    const isSuper = user_role === role.SUPPER_ADMIN
    const managedIds = managedHeThongIds
    const visibleSystems = isSuper
      ? (Array.isArray(systems) ? systems : [])
      : (Array.isArray(systems) ? systems.filter((s: any) => managedIds.includes(Number(s.id))) : [])
    return visibleSystems.map((item, index) => ({
      key: `system-${index}`,
      className: `theme-menu-item ${item.ma === systemInfo?.ma ? 'active' : ''}`,
      label: item.ten,
      onClick: () => changeHeThong(item),
    }))
  })()

  return (
    <header className="ant-layout-header">
      <style>{`
        .navbar-user-trigger .navbar-username {
          max-width: 160px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          vertical-align: middle;
        }
      `}</style>
      <div className="navbar-custom">
        {/* Left side menus */}
        <div className="navbar-left">
          <div className="theme-switcher-container header-outlined-control">
            <Dropdown
              trigger={['click']}
              placement="bottomRight"
              menu={{ items: systemMenuItems, className: 'theme-dropdown-menu' }}
            >
              <div className="theme-switcher-button">
                <div className="theme-switcher-content">
                  <AppstoreOutlined style={{ fontSize: '16px' }} />
                  <span>Phần mềm {systemInfo?.ten}</span>
                </div>
              </div>
            </Dropdown>
          </div>

          {userMenu(user_role).map((menuItem: any) => {
            if (menuItem.children && menuItem.children.length > 0) {
              const isChildActive = menuItem.children.some((subMenu: any) => pathname.includes(subMenu.startPoint))
              const isActive = isChildActive || (menuItem.startPoint && pathname.includes(menuItem.startPoint))
              return (
                <div className={`theme-switcher-container ${isActive ? 'active' : ''}`} key={menuItem.key}>
                  <Dropdown
                    placement="bottomLeft"
                    menu={{
                      className: 'theme-dropdown-menu',
                      items: menuItem.children.map((subMenu: any, index2: number) => ({
                        key: menuItem.key + "-" + index2,
                        className: `theme-menu-item ${pathname.includes(subMenu.startPoint) ? 'active' : ''}`,
                        label: (
                          <Link to={subMenu.path}>
                            <div className="theme-switcher-content">
                              {subMenu.icon && React.createElement(subMenu.icon, { style: { fontSize: '16px' } })}
                              <span>{subMenu.label}</span>
                            </div>
                          </Link>
                        ),
                      })),
                    }}
                  >
                    <div className={`theme-switcher-button ${isActive ? 'active' : ''}`}>
                      <div className="theme-switcher-content">
                        {menuItem.icon && React.createElement(menuItem.icon, { style: { fontSize: '16px' } })}
                        <span>{menuItem.label}</span>
                      </div>
                    </div>
                  </Dropdown>
                </div>
              );
            }
            return (
              <div 
                className={`theme-switcher-container ${pathname.includes(menuItem.startPoint) ? 'active' : ''}`} 
                key={menuItem.key}
                data-menu={menuItem.key}
              >
                <Link to={menuItem.path}>
                  <div className={`theme-switcher-button ${pathname.includes(menuItem.startPoint) ? 'active' : ''}`}>
                    <div className="theme-switcher-content">
                      {menuItem.icon && React.createElement(menuItem.icon, { style: { fontSize: '16px' } })}
                      <span>{menuItem.label}</span>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>

        {/* Right side menus */}
        <div className="navbar-right">
          {canSyncUser && (
            <div className="theme-switcher-container header-outlined-control">
              <div className="theme-switcher-button">
                <div className="theme-switcher-content">
                  <Button
                    icon={<SyncOutlined />}
                    onClick={handleSyncUser}
                    type="text" size="small"
                    className="hover:text-blue-500">
                    <span>Đồng bộ user</span>
                  </Button>
                </div>
              </div>
            </div>
          )}
          <div className="theme-switcher-container header-outlined-control">
            <Dropdown
              trigger={['click']}
              placement="bottomRight"
              menu={{
                className: 'theme-dropdown-menu',
                items: [
                  {
                    key: 'logout',
                    className: 'theme-menu-item',
                    label: 'Đăng xuất',
                    onClick: () => logOut(),
                  },
                  {
                    key: 'changePwd',
                    className: 'theme-menu-item',
                    label: <Link to={routerConstants.user.changePWD}>Đổi mật khẩu</Link>,
                  },
                ],
              }}
            >
              <div className="theme-switcher-button navbar-user-trigger">
                <div className="theme-switcher-content">
                  <UserOutlined style={{ fontSize: '16px', flexShrink: 0 }} />
                  <span className="navbar-username" title={displayUsername}>
                    {displayUsername || 'Tài khoản'}
                  </span>
                </div>
              </div>
            </Dropdown>
          </div>

          <ThemePickerPopover />
        </div>
      </div>
    </header>
  )
}

export default HeaderMenu
